var _path, _path2, _path3, _path4, _path5, _path6, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMicroscope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5603 3.4395L41.5603 0.439499C40.9753 -0.146251 40.0243 -0.146251 39.4393 0.439499L37.4998 2.379L37.0603 1.9395C36.4753 1.35375 35.5243 1.35375 34.9393 1.9395L24.4393 12.4395C23.8536 13.0252 23.8536 13.9747 24.4393 14.5605L24.8781 15L21.4393 18.4395C20.8536 19.0252 20.8536 19.9747 21.4393 20.5605L24.4393 23.5605C24.7318 23.8537 25.1158 24 25.4998 24C25.8838 24 26.2678 23.8537 26.5603 23.5605L29.9998 20.121L30.4393 20.5605C31.0243 21.1462 31.9753 21.1462 32.5603 20.5605L43.0603 10.0605C43.6461 9.47475 43.6461 8.52525 43.0603 7.9395L42.6216 7.5L44.5603 5.5605C45.1461 4.97475 45.1461 4.02525 44.5603 3.4395Z",
    fill: "url(#paint0_linear_1040_63)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9998 34.5C17.6158 34.5 17.2318 34.3538 16.9393 34.0605L10.9393 28.0605C10.3536 27.4748 10.3536 26.5252 10.9393 25.9395C11.5243 25.3537 12.4753 25.3537 13.0603 25.9395L19.0603 31.9395C19.6461 32.5252 19.6461 33.4748 19.0603 34.0605C18.7678 34.3538 18.3838 34.5 17.9998 34.5Z",
    fill: "url(#paint1_linear_1040_63)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0603 7.9395L37.0603 1.9395C36.4753 1.35375 35.5243 1.35375 34.9393 1.9395L24.4393 12.4395C23.8536 13.0252 23.8536 13.9747 24.4393 14.5605L30.4393 20.5605C30.7318 20.8537 31.1158 21 31.4998 21C31.8838 21 32.2678 20.8537 32.5603 20.5605L43.0603 10.0605C43.6461 9.47475 43.6461 8.52525 43.0603 7.9395Z",
    fill: "url(#paint2_linear_1040_63)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8788 15L21.4393 18.4395C20.8536 19.0253 20.8536 19.9747 21.4393 20.5605L24.4393 23.5605C24.7318 23.8537 25.1158 24 25.4998 24C25.8838 24 26.2678 23.8537 26.5603 23.5605L29.9998 20.121L24.8788 15Z",
    fill: "url(#paint3_linear_1040_63)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2889 37.7887C46.2354 30.8422 46.8504 19.8533 40.9524 12.1695L38.8217 14.3003C43.5579 20.7848 42.9504 29.8853 37.1679 35.6677C34.0502 38.784 29.9064 40.5 25.5002 40.5C21.0939 40.5 16.9502 38.784 13.8324 35.6677C13.4447 35.28 13.0734 34.8645 12.7104 34.4115L15.0002 32.121L12.8792 30L9.67216 33.207C9.15766 33.7215 9.08641 34.5293 9.50191 35.1255C10.2047 36.1343 10.9269 37.005 11.7114 37.7887C15.0392 41.1157 19.3577 43.086 24.0002 43.4378V45H18.0002C17.1722 45 16.5002 45.672 16.5002 46.5C16.5002 47.328 17.1722 48 18.0002 48H33.0002C33.8282 48 34.5002 47.328 34.5002 46.5C34.5002 45.672 33.8282 45 33.0002 45H27.0002V43.4378C31.6427 43.086 35.9612 41.1157 39.2889 37.7887Z",
    fill: "url(#paint4_linear_1040_63)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7113 37.7887C11.1646 37.242 10.6486 36.6488 10.1468 36H8.12107L5.55982 33.4395C4.97482 32.8537 4.02382 32.8537 3.43882 33.4395C2.85307 34.0252 2.85307 34.9748 3.43882 35.5605L6.43882 38.5605C6.72082 38.8418 7.10257 39 7.50007 39H13.0418C12.5836 38.6175 12.1388 38.2155 11.7113 37.7887Z",
    fill: "url(#paint5_linear_1040_63)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1040_63",
    x1: 22.9393,
    y1: 22.0613,
    x2: 43.0611,
    y2: 1.94025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1040_63",
    x1: 13.9393,
    y1: 31.0612,
    x2: 16.0611,
    y2: 28.9402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADF9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1040_63",
    x1: 27.4393,
    y1: 17.5605,
    x2: 40.0611,
    y2: 4.9395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7055C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D055C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1040_63",
    x1: 22.9393,
    y1: 22.0612,
    x2: 27.4401,
    y2: 17.5612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADF9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1040_63",
    x1: 15.8147,
    y1: 46.4355,
    x2: 45.5169,
    y2: 16.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1040_63",
    x1: 6.17032,
    y1: 38.2912,
    x2: 9.30382,
    y2: 35.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7055C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D055C2"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroscope);
export default __webpack_public_path__ + "static/media/microscope.4f5f959b093232e4632ed7a9fb9f37cd.svg";
export { ForwardRef as ReactComponent };